import React, { Component, PropTypes } from 'react';
import StoreList from 'components/Store/StoreList';
import StoreGrid from 'components/Store/StoreGrid';
import StoreCards from 'components/Store/StoreCards';
import StoreFilter from 'containers/Store/StoreFilter';
import { getFilteredStoreItems } from 'selectors/store';
import { history } from 'helpers';

class StoreListModule extends Component {
  static propTypes = {
    store: PropTypes.string,
    items: PropTypes.array,
    storeItems: PropTypes.array,
    filter: PropTypes.object,
    themeColor: PropTypes.string,
    mode: PropTypes.string,
    canIEdit: PropTypes.bool,
    searchText: PropTypes.string
  };

  static contextTypes = {
    router: PropTypes.object
  };

  gotoItem = item => {
    const { type } = item;
    const { store } = this.props;

    if (type === 2) {
      history.push(`/store/package/${store}/${item.slug}`);
    } else {
      history.push(`/store/${store}/${item.slug}`);
    }
  };

  render() {
    const {
      themeColor,
      storeItems,
      filter,
      items,
      store,
      searchText,
      canIEdit,
      ...other
    } = this.props;
    const mode = this.props.mode || 'grid';
    const tags = (filter && filter.tags) || {};
    const hasFilter =
      filter && (filter.categoryId || Object.keys(tags).some(tag => tags[tag]));
    return (
      <div>
        {mode === 'list' && (
          <StoreList
            onTouchTapItem={this.gotoItem}
            themeColor={themeColor}
            displayFilter={!!filter}
            canIEdit={canIEdit}
            items={
              hasFilter
                ? getFilteredStoreItems(storeItems, { ...filter, searchText })
                : items
            }
            username={store}
            {...other}
          />
        )}
        {mode === 'grid' && (
          <StoreGrid
            onTouchTapItem={this.gotoItem}
            themeColor={themeColor}
            displayFilter={!!filter}
            canIEdit={canIEdit}
            items={
              hasFilter
                ? getFilteredStoreItems(storeItems, { ...filter, searchText })
                : items
            }
            username={store}
            {...other}
          />
        )}
        {mode === 'cards' && (
          <StoreCards
            onTouchTapItem={this.gotoItem}
            themeColor={themeColor}
            displayFilter={!!filter}
            canIEdit={canIEdit}
            items={
              hasFilter
                ? getFilteredStoreItems(storeItems, { ...filter, searchText })
                : items
            }
            username={store}
            {...other}
          />
        )}
      </div>
    );
  }
}

export default StoreListModule;



// WEBPACK FOOTER //
// ./src/js/components/Store/Modules/StoreListModule.js